import { render, staticRenderFns } from "./InvoiceDetailsSection.vue?vue&type=template&id=26bc2f26&scoped=true"
import script from "./InvoiceDetailsSection.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsSection.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsSection.vue?vue&type=style&index=0&id=26bc2f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc2f26",
  null
  
)

export default component.exports